var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * 过滤出number的tags和string的tags
 * @param tags
 * @returns
 */
export var formatTags = function (tags, omitNumber) {
    if (omitNumber === void 0) { omitNumber = true; }
    var numberTags = {};
    var stringTags = {};
    Object.keys(tags).forEach(function (key) {
        // 过滤number的tags
        if (omitNumber && typeof tags[key] === 'number') {
            numberTags[key] = tags[key];
            return;
        }
        try {
            // 除number的tags，如果非string，进行序列化，序列化失败忽略该key
            stringTags[key] = typeof tags[key] === 'string' ? tags[key] : JSON.stringify(tags[key]);
        }
        catch (e) { }
    });
    return [numberTags, stringTags];
};
// 判断是否是Error
var isError = function (error) { return error instanceof Error; };
// 判断值是否为空
var isEmptyValue = function (value) { return value === undefined || value === null; };
/**
 * 从对象中获取数据赋
 * @param obj 被取值的对象
 * @param keys 键的数组，可以指定返回不同的key
 * @returns 返回能取到值的对象，空值会被过滤
 */
var getDataFromObject = function (obj, keys) {
    var target = {};
    if (typeof obj !== 'object') { // 不是对象，返回空的
        return target;
    }
    keys.forEach(function (key) {
        var realSourceKey = typeof key === 'object' ? key.source : key;
        var realTargetKey = typeof key === 'object' ? key.target : key;
        // 存在该键，并且值不为空时，保存
        if (realSourceKey in obj && !isEmptyValue(obj[realSourceKey])) {
            target[realTargetKey] = obj[realSourceKey];
        }
    });
    return target;
};
// 获取请求信息
export var getRequestInfo = function (tags) {
    var _a = tags || {}, request = _a.request, response = _a.response;
    if (!request) { // 无request，非fetch请求
        return null;
    }
    var _b = request.method, method = _b === void 0 ? '' : _b;
    var extra = {};
    // 获取request数据: url、data
    var dataAndUrl = getDataFromObject(request, ['url', { source: 'data', target: 'request' }]);
    extra = __assign(__assign({}, extra), dataAndUrl);
    var level = 'custom';
    var describe = '';
    // 接口已有返回值，尝试获取code、process_exec_code等信息
    if (response && !(response instanceof Response)) {
        extra.response = response;
        // 获取code、logId、process_id、process_exec_code
        var _c = response.data, data = _c === void 0 ? {} : _c;
        var codeObj = getDataFromObject(response, ['code', 'logId']);
        var processObj = getDataFromObject(data, ['process_id', 'process_exec_code']);
        extra = __assign(__assign(__assign({}, extra), codeObj), processObj);
    }
    // 非流程接口或关闭code中间件时，response只能获取到status、logId等字段
    if (response instanceof Response) {
        var status_1 = response.status, headers = response.headers;
        var logId = headers.get('x-tt-logid') || '';
        var statusReason = "".concat(method, " ").concat(status_1);
        describe = "\u7F51\u7EDC\u8BF7\u6C42 ".concat(statusReason);
        extra.logId = logId;
        // 1xx 2xx 3xx 认为是正常请求，上报info就可以
        if (status_1 >= 400) {
            describe = "\u7F51\u7EDC\u9519\u8BEF ".concat(statusReason);
            level = /^4\d\d$/.test("".concat(status_1)) ? 'error' : 'warn';
        }
    }
    return {
        level: level,
        describe: describe,
        extra: extra
    };
};
/**
 * 处理错误的信息
 * @param defaultLevel 报错等级
 * @param label 业务模块
 * @param describe 描述
 * @param err Error
 * @param defaultTags 额外信息
 * @returns
 */
export var errorHandler = function (defaultLevel, label, describe, err, defaultTags) {
    if (err === void 0) { err = new Error(''); }
    if (defaultTags === void 0) { defaultTags = {}; }
    var error = err;
    if (!isError(err)) {
        error = new Error(JSON.stringify(err));
    }
    var messageFromError = error.message;
    var level = defaultLevel;
    var reason = messageFromError;
    var _a = formatTags(defaultTags, false), _ = _a[0], stringTags = _a[1];
    var extra = __assign(__assign({}, stringTags), { messageFromError: messageFromError });
    extra.level = level;
    extra.reason = reason;
    return {
        level: level,
        label: label,
        describe: describe,
        error: error,
        extra: extra
    };
};
// 带颜色的打印
export var prettyPrint = function (info) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var label = info.label, _a = info.bold, bold = _a === void 0 ? true : _a, color = info.color;
    var colorStyle = color ? "color: ".concat(color, ";") : '';
    var boldStyle = bold ? 'font-weight: bold;' : '';
    console.log.apply(console, __spreadArray(["%c".concat(label), "".concat(colorStyle, " ").concat(boldStyle)], args, false));
};
// 不同等级对应的颜色
export var level2color = function (level) {
    switch (level) {
        case 'fatal':
            return '#f00';
        case 'error':
            return '#e33';
        case 'warn':
            return '#f4bd02';
        default:
            return '';
    }
};
//# sourceMappingURL=utils.js.map